import { render, staticRenderFns } from "./PropertyDocuments.vue?vue&type=template&id=5ab146aa&"
import script from "./PropertyDocuments.vue?vue&type=script&lang=js&"
export * from "./PropertyDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports